<sbw-layout [backButtonVisible]="false" [continueButtonVisible]="false" [quoteShowTotalPrice]="true" quoteStep="Payment"
    [quoteShowDepartureTime]="true">
    <div class="sbw_pagebox">
        <div class="payment-container">
            <h1>{{ 'PAYMENT_DETAILS' | resource }}</h1>
            <p>{{'PAYMENT_INFO' | resource}}</p>
            <p>
                {{'PAYMENT_MECHANISM_NOTE' | resource}}
                <a href="passengers">{{'PAYMENT_MECHANISM_LINK_TEXT' | resource}}</a>
            </p>
            <div class="payment-form">
                <div class="row">
                    <div class="column small-12 medium-5 large-4 xlarge-3 label">
                        {{ 'AMOUNT_TO_PAY' | resource }}</div>
                    <div class="column small-12 medium-7 large-8 xlarge-9 field">
                        <strong>
                            <!--Important - no space or newline between currency and amount-->
                            <span>{{ currency | resource }}</span><span id="amount">{{amount | resourceformat:'CURRENCY_FORMAT'}}</span>
                        </strong>
                    </div>
                </div>
                <div class="row">
                    <div class="column small-12 medium-5 large-4 xlarge-3 label">{{'PAYMENT_MECHANISM' | resource}}
                    </div>
                    <div class="column small-12 medium-7 large-8 xlarge-9 field">
                        <strong>{{mechanism}}</strong>
                    </div>
                </div>
                <form id="PensioPaymentForm">
                    <div style="border: 2px solid; padding: 14px; background-color: yellow">
                        <strong>All content in here will be replaced by the actual payment form.</strong>
                        Identified by the id PensioPaymentForm - please don't remove.
                    </div>
                </form>
            </div>
            <p class="noBottom">
                <strong> {{ 'LOADING_MESSAGE_1' | resource}}</strong>
            </p>
            <p>
                {{ 'LOADING_MESSAGE_2' | resource}}
            </p>
            <div class="row">
                <div class="column small-12 medium-4 medium-push-8 large-3 large-push-9 field submit">
                    <button class="preferred-action PensioSubmitButton"
                        disabled="">{{ 'PAY_AND_BOOK' | resource }}</button>
                </div>
                <div class="column small-12 medium-4 medium-pull-8 large-3 large-pull-9 field submit">
                    <a class="previous-action" href="passengers">{{ 'BACK' | resource }}</a>
                </div>
            </div>
        </div>
    </div>
</sbw-layout>
